import classNames from 'classnames'

export default function className(defaultStyle, style) {
  return classNames({ [defaultStyle]: !style, [style]: true })
}
